var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"padding",attrs:{"to":_vm.to,"fixed":"","bottom":"","light":"","round":"","large":"","color":"white"}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }